import React from 'react';
import styles from './upc-support-page.module.scss';
import { UpcFooter, WdayLogo } from '../shared';

interface UpcSupportPageProp {
    id?: string;
    children: JSX.Element;
}

export function UpcSupportPage({ children }: UpcSupportPageProp) {
    return (
        <div className={styles.page}>
            <main className={styles.component}>
                <WdayLogo className={styles.logo} />
                {children}
            </main>
            <UpcFooter className={styles.footer} isAuthenticated={false} />
        </div>
    );
}
